"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const Table_1 = __importDefault(require("@mui/material/Table"));
const formik_2 = require("formik");
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const DynamicTableRow_1 = __importDefault(require("@/components/DynamicTable/DynamicTableRow"));
const DyanmicTableHead_1 = __importDefault(require("@/components/DynamicTable/DyanmicTableHead"));
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const Input_1 = __importDefault(require("@/components/Input"));
const Button_1 = __importDefault(require("@/components/Button"));
const TableLoader_1 = __importDefault(require("@/components/TableLoader"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const PortsPrompt_1 = __importDefault(require("../PortsPrompt"));
const constants_1 = require("./constants");
const styles_1 = require("./styles");
function PortsTableView({ rows, isLoading, onOpenSavePrompt, isCountrySelected, }) {
    const formik = (0, formik_2.useFormikContext)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && (react_1.default.createElement(TableLoader_1.default, { tableLoaderStyle: { height: "300px", marginBottom: "120px" } })),
        !isLoading && isCountrySelected && (react_1.default.createElement(styles_1.StyledForm, null,
            react_1.default.createElement(formik_1.FieldArray, { name: "ports", validateOnChange: true }, (arrayHelpers) => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(styles_1.ScrollableTableContainer, null,
                        react_1.default.createElement(Table_1.default, { stickyHeader: true, sx: { height: "fit-content" } },
                            react_1.default.createElement(DyanmicTableHead_1.default, { tableHeadCells: constants_1.TABLE_HEAD_CELLS }),
                            react_1.default.createElement(TableBody_1.default, null,
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    rows["ports"].length === 0 && (react_1.default.createElement(styles_1.NoPortsFoundSection, null,
                                        react_1.default.createElement(styles_1.NoPortsFoundTitle, { variant: "h4" },
                                            " ",
                                            "No ports found. Click on the button below to include a new port."))),
                                    rows["ports"]?.map((row, index) => {
                                        const errorMessage = formik?.errors?.ports &&
                                            formik?.errors?.ports[index]
                                            ? formik?.errors?.ports[index]
                                            : "";
                                        return (react_1.default.createElement(DynamicTableRow_1.default, { key: `port-${index}` }, formik.initialValues["ports"][index] ===
                                            row ? (react_1.default.createElement(react_1.default.Fragment, null,
                                            react_1.default.createElement(SimpleCell_1.default, null,
                                                " ",
                                                row,
                                                " "),
                                            react_1.default.createElement(SimpleCell_1.default, null, " "))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                            " ",
                                            react_1.default.createElement(SimpleCell_1.default, { variant: "body" },
                                                react_1.default.createElement(Input_1.default, { onChange: arrayHelpers.form.handleChange, name: `ports[${index}]`, error: Boolean(errorMessage), helperText: errorMessage, value: row, id: `ports[${index}]` })),
                                            react_1.default.createElement(DeletableCell_1.default, { onDelete: () => {
                                                    arrayHelpers.remove(index);
                                                }, align: "right" })))));
                                    }))))),
                    react_1.default.createElement(styles_1.AddPortSection, null,
                        react_1.default.createElement(Button_1.default, { label: "Add Port", variant: "outlined", color: "secondary", disabled: arrayHelpers.form.values["ports"][arrayHelpers.form.values["ports"].length - 1] === "", onClick: () => {
                                arrayHelpers.push("");
                                onOpenSavePrompt();
                            } }))));
            }),
            react_1.default.createElement(PortsPrompt_1.default, null)))));
}
exports.default = PortsTableView;
